import { useTranslation } from 'react-i18next';
import { Layout } from "@/components/Layout";
import { SEO } from "@/components/SEO";
import headerImage from "@/assets/headers/header-sobre-umbanda.jpg";

const SobreUmbanda = () => {
  const { t } = useTranslation();

  return (
    <Layout>
      <SEO 
        title={t('aboutUmbanda.seoTitle')}
        description={t('aboutUmbanda.seoDescription')}
        keywords="umbanda tradicional, orixás, candomblé, religiões afro-brasileiras, espaço sagrado, energia espiritual, terreiro orlando"
        canonicalUrl={`${window.location.origin}/sobre-umbanda`}
      />
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="relative py-24 overflow-hidden">
        <div 
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{ backgroundImage: `url(${headerImage})` }}
        />
        <div className="absolute inset-0 bg-logo-brown-dark/70" />
        <div className="relative z-10 text-center px-4 container mx-auto">
          <h1 className="font-display text-5xl md:text-7xl text-logo-beige mb-6 font-bold">
            {t('aboutUmbanda.title')}
          </h1>
          <p className="text-xl md:text-2xl text-white/90 max-w-3xl mx-auto font-body">
            {t('aboutUmbanda.subtitle')}
          </p>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-20 bg-background">
        <div className="container mx-auto px-4 max-w-4xl">
          
          {/* Pilar 1 */}
          <div className="mb-16 animate-fade-in">
            <div className="mb-6">
              <h2 className="font-display text-4xl text-primary font-bold">
                {t('aboutUmbanda.traditional.title')}
              </h2>
            </div>
            <div className="space-y-4 text-foreground/80 leading-relaxed font-body text-lg">
              <p>{t('aboutUmbanda.traditional.text1')}</p>
              <p>{t('aboutUmbanda.traditional.text2')}</p>
              <p>{t('aboutUmbanda.traditional.text3')}</p>
            </div>
          </div>

          <div className="h-px bg-gradient-to-r from-transparent via-secondary to-transparent my-12" />

          {/* Pilar 2 */}
          <div className="mb-16 animate-fade-in">
            <div className="mb-6">
              <h2 className="font-display text-4xl text-primary font-bold">
                {t('aboutUmbanda.sacredSpace.title')}
              </h2>
            </div>
            <div className="space-y-4 text-foreground/80 leading-relaxed font-body text-lg">
              <p>{t('aboutUmbanda.sacredSpace.text1')}</p>
              <p>{t('aboutUmbanda.sacredSpace.text2')}</p>
              <p>{t('aboutUmbanda.sacredSpace.text3')}</p>
            </div>
          </div>

          <div className="h-px bg-gradient-to-r from-transparent via-secondary to-transparent my-12" />

          {/* Pilar 3 */}
          <div className="mb-16 animate-fade-in">
            <div className="mb-6">
              <h2 className="font-display text-4xl text-primary font-bold">
                {t('aboutUmbanda.energy.title')}
              </h2>
            </div>
            <div className="space-y-4 text-foreground/80 leading-relaxed font-body text-lg">
              <p>{t('aboutUmbanda.energy.text1')}</p>
              <p>{t('aboutUmbanda.energy.text2')}</p>
              <p>{t('aboutUmbanda.energy.text3')}</p>
              <p>{t('aboutUmbanda.energy.text4')}</p>
            </div>
          </div>

          <div className="h-px bg-gradient-to-r from-transparent via-secondary to-transparent my-12" />

          {/* Pilar 4 */}
          <div className="mb-16 animate-fade-in">
            <div className="mb-6">
              <h2 className="font-display text-4xl text-primary font-bold">
                {t('aboutUmbanda.openDoors.title')}
              </h2>
            </div>
            <div className="space-y-4 text-foreground/80 leading-relaxed font-body text-lg">
              <p>{t('aboutUmbanda.openDoors.text1')}</p>
              <p>{t('aboutUmbanda.openDoors.text2')}</p>
              <p>{t('aboutUmbanda.openDoors.text3')}</p>
              <p>{t('aboutUmbanda.openDoors.text4')}</p>
            </div>
          </div>

          <div className="text-center mt-20 py-12 bg-logo-brown-dark/60 rounded-2xl border-2 border-secondary/30">
            <p className="font-display text-5xl text-white text-glow mb-4">{t('aboutUmbanda.closing')}</p>
          </div>

        </div>
      </section>
    </div>
    </Layout>
  );
};

export default SobreUmbanda;
